import React from 'react';
import { Progress } from '@/components/ui/progress';
import { useXP } from '@/hooks/useXP';

const LEVEL_ICONS: Record<string, string> = {
  Bronze: '🥉',
  Silver: '🥈',
  Gold: '🥇',
  Platinum: '💎',
  Diamond: '💠',
  Elite: '👑',
};

export const XPBar: React.FC = () => {
  const { levelData, loading } = useXP();

  if (loading || !levelData) {
    return (
      <div className="animate-pulse">
        <div className="h-4 bg-muted rounded-full w-full" />
      </div>
    );
  }

  const icon = LEVEL_ICONS[levelData.levelName] || '🥉';

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-sm">
        <div className="flex items-center gap-2">
          <span className="text-lg">{icon}</span>
          <span className="font-semibold text-foreground">
            {levelData.levelName} • Level {levelData.level}
          </span>
        </div>
        <span className="text-muted-foreground">
          {levelData.currentXP} / {levelData.xpForNextLevel} XP
        </span>
      </div>
      <Progress value={levelData.progress} className="h-2" />
    </div>
  );
};
